import { useEffect, useState } from 'react';

export const useReadyForCypress = (readyIdentifier: string): string => {
  const [loaded, setLoaded] = useState<boolean>(false);
  useEffect(() => {
    setLoaded(true);
  }, []);

  return loaded ? readyIdentifier : '';
};
